import AbstractTab from "../AbstractTab";
import SpeciesRow from "../SpeciesRow";

export default class ListsTab extends AbstractTab {
    listsLoaded = false;
    listData = {};
    rows = [];
    name = 'lists';
    tooltip = 'Lists (L)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#list-unordered"></use></svg>';

    constructor(provider, tabContainer) {
        super(provider);
        this.listInput = this.p.createDiv().parent(tabContainer);
        this.positionListSelector();

        if (username) {
            this.createListSelector();
        } else {
            this.placeholder = this.p.createElement('p', 'Log in to see your lists')
                .parent(this.listInput)
                .class('pad');
        }

        this.listInput.hide();
    }

    createListSelector() {
        this.listInput.class("planner-aside-wrapper");
        let listLabel = this.p.createElement('h3', 'Lists')
            .parent(this.listInput)
            .class('mar-t-0 mar-b');
        let inputGroup = this.p.createDiv().parent(this.listInput)
            .class("input-group");
        let selectWrapper = this.p.createDiv().parent(this.listInput)
            .class("input-select-wrapper");
        // listLabel.position(10, 10);
        this.sel = this.p.createSelect()
            .parent(selectWrapper)
            .id('list-select');
        this.sel.changed(() => this.selectList());
        this.sel.option('Choose list to import', null);
        // this.sel.position(10, 30);
        this.sel.class("input-select");
    }

    positionListSelector() {
        // this.listInput.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        this.positionListSelector();
    }

    activate() {
        if (username && !this.listsLoaded) {
            this.dataHandler.loadLists((data) => this.buildOptions(data));
        }
        this.listInput.show();
    }

    deactivate() {
        this.spinner.reset();
        this.listInput.hide();
    }

    buildOptions(data) {
        this.listsLoaded = true;
        for (let [key, value] of Object.entries(data)) {
            if (value.plants.length == 0) {
                continue;
            }
            this.sel.option(value.name, key);
            let rowContainer = this.p.createDiv()
                .parent(this.listInput)
                .class('pad-b listcontainer')
                .id('listcontainer-' + key)
            this.listData[key] = value.plants.map(plant => new SpeciesRow(this.provider, plant, rowContainer).without(['remove']));
            rowContainer.hide();
        }
    }

    selectList() {
        this.p.selectAll('.listcontainer').map((container) => container.hide());
        this.p.select('#listcontainer-' + this.sel.value()).show();
    }
}
